import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { useIsFramedCentredStep } from '../hooks/useIsFramedCentredStep';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { HaveAnAccountLink } from '../step-landing-page/HaveAnAccountLink';
import { getIsAuthenticated } from '../store/auth/selectors';
import { getActiveError } from '../store/error/selectors';
import { getActiveLoading } from '../store/loading-status/selectors';
import { devices } from '../styles/viewports.styles';
import { BackLink } from '../views-components/BackLink';
import HubSpotLogo from '../views-components/HubSpotLogo';
import { ProgressIndicator } from '../views-components/ProgressIndicator';
import { Step } from '../views/Step';
export const Header = styled.div.withConfig({
  displayName: "AppHeader__Header",
  componentId: "sc-9ifaky-0"
})(["grid-column-start:2;grid-column-end:span 3;display:flex;justify-content:space-between;align-items:center;margin:1rem 0;@media ", "{margin:8px;align-items:center;}"], devices.desktop);
const Logo = styled.div.withConfig({
  displayName: "AppHeader__Logo",
  componentId: "sc-9ifaky-1"
})(["order:1;@media ", "{margin-top:1rem;order:initial;}"], devices.desktop);
export const AppHeader = () => {
  const {
    isFramedCentredStep
  } = useIsFramedCentredStep();
  const {
    isDesktop
  } = useResponsiveness();
  const showBackLink = isFramedCentredStep && !isDesktop || !isFramedCentredStep && !isDesktop;
  const {
    currentStep
  } = useCurrentStep();
  const isAuthenticated = useSelector(getIsAuthenticated);
  const shouldShowSignInButton = getFlowConfig().shouldShowSignInButton;
  const currentLoading = useSelector(getActiveLoading);
  const currentError = useSelector(getActiveError);
  const shouldDiplayAccountLink = [Step.LandingPage].includes(currentStep) && !isAuthenticated && shouldShowSignInButton && !currentLoading && !currentError;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(ProgressIndicator, {}), /*#__PURE__*/_jsxs(Header, {
      children: [/*#__PURE__*/_jsx(Logo, {
        children: /*#__PURE__*/_jsx(HubSpotLogo, {})
      }), /*#__PURE__*/_jsxs("div", {
        children: [shouldDiplayAccountLink && /*#__PURE__*/_jsx(HaveAnAccountLink, {}), showBackLink && /*#__PURE__*/_jsx(BackLink, {})]
      })]
    })]
  });
};